/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import Cookies from 'universal-cookie';

const cookies = new Cookies();

const parseBannerCookie = (bannerCookie) => {
    if (typeof bannerCookie !== 'string') return bannerCookie;

    try {
        return JSON.parse(bannerCookie);
    } catch (error) {
        return null;
    }
};

const getBannerPromoCode = (bannerCookie) => {
    const banner = parseBannerCookie(bannerCookie);
    return typeof banner?.p === 'string' ? banner.p.trim() : '';
};

const addPromotionCodeVariant = (variants = [], promotionCode = '') => {
    if (!promotionCode) return variants;

    return [
        ...variants.filter(({ name }) => name !== 'PROMOTION_CODE'),
        {
            name: 'PROMOTION_CODE',
            value: promotionCode,
        },
    ];
};

const isAlreadyDiscounted = (skuPriceRange = {}) => {
    const salePrices = skuPriceRange?.sale || [];
    const retailPrices = skuPriceRange?.retail || [];

    return salePrices.some((salePrice, index) => {
        const retailPrice = retailPrices[index] || retailPrices[0];
        return Number(salePrice?.value) < Number(retailPrice?.value);
    });
};

const getBannerCookie = () => cookies.get('banner');

const setBannerCookie = (value, options) => {
    cookies.set('banner', value, options);
};

const subscribeToBannerCookie = (listener) => {
    const handleCookieChange = ({ name, value }) => {
        if (name === 'banner') listener(value);
    };

    cookies.addChangeListener(handleCookieChange);
    return () => cookies.removeChangeListener(handleCookieChange);
};

export default {
    getBannerPromoCode,
    addPromotionCodeVariant,
    isAlreadyDiscounted,
    getBannerCookie,
    setBannerCookie,
    subscribeToBannerCookie,
};
